// src/components/ui/button.jsx
import React from 'react';
import '../ui/Button.css';

export const Button = ({
  children,
  onClick,
  type = 'button',
  style,
  className = '',
  disabled = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      style={style}
      className={`custom-button ${className}`}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};
